import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'ForgotPasswordInformationUsername' })({
  input: {
    background: 'initial',
    backgroundColor: 'white',
  },
});
